module.exports = __webpack_public_path__ + "img/0Q3A2940_FoamcoreMatted.0196b8e6.jpg";